interface LevelProgress {
  progress: any
  type: any
}

export function calculateLevelProgress(levels: number[], currentExp: number) {
  const percents = [10, 30, 50, 70, 100]

  // 查找当前等级（最后一个 ≤ currentExp 的等级）
  let level = 0
  for (let i = 0; i < levels.length; i++) {
    if (currentExp >= levels[i]) level = i
  }

  // 满级（直接 100%）
  if (level === levels.length - 1) {
    return { progress: 100, type: level + 1 }
  }

  const baseExp = levels[level]
  const nextExp = levels[level + 1]

  const basePercent = percents[level]      // 当前等级起点百分比
  const nextPercent = percents[level + 1]  // 下一级百分比
  const diffPercent = nextPercent - basePercent

  // 当前等级区间内的实际进度
  const percent =
    basePercent +
    ((currentExp - baseExp) / (nextExp - baseExp)) * diffPercent

  return {
    progress: Math.min(percent, 100),
    type: level + 1
  }
}


/**
 * 格式化时间显示
 */
export function formatTime(timestamp: number, t: any): string {
  const date = new Date(timestamp)
  const now = new Date()
  const diff = now.getTime() - date.getTime()

  // 小于1分钟显示"刚刚"
  if (diff < 60000) {
    return t('just_now')
  }

  // 小于1小时显示分钟
  if (diff < 3600000) {
    const minutes = Math.floor(diff / 60000)
    return `${minutes} ${t('minutes_ago')}`
  }

  // 小于24小时显示小时
  if (diff < 86400000) {
    const hours = Math.floor(diff / 3600000)
    return `${hours} ${t('hours_ago')}`
  }

  // 其他情况显示具体时间
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  if (date.getTime() >= today.getTime()) {
    // 今天
    return date.toLocaleTimeString('zh-CN', {
      hour: '2-digit',
      minute: '2-digit'
    })
  } else if (date.getTime() >= today.getTime() - 86400000) {
    // 昨天
    return `${t('yesterday')} ${date.toLocaleTimeString('zh-CN', {
      hour: '2-digit',
      minute: '2-digit'
    })}`
  } else {
    // 更早
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }
}
